module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "400"
    },
    model: {
      value: (_vm.$parent.popup.isVisible),
      callback: function($$v) {
        _vm.$parent.popup.isVisible = $$v
      },
      expression: "$parent.popup.isVisible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "trHeader",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$parent.popup.title))])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        שם סטטוס\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.popup.data.Name),
      expression: "$parent.popup.data.Name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$parent.popup.data.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.popup.data.Name = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "right": ""
    }
  }, [_vm._v("\n        צבע\n      ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('ColorPicker', {
    ref: "colorPicker",
    model: {
      value: (_vm.$parent.popup.colors),
      callback: function($$v) {
        _vm.$parent.popup.colors = $$v
      },
      expression: "$parent.popup.colors"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "10px 10px 10px 10px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "error"
  }, [_vm._v("* " + _vm._s(_vm.error))])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "20px 10px 10px 10px"
    },
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    staticClass: "green green--text ml-3",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.save($event)
      }
    }
  }, [_vm._v("\n        שמירה\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "red red--text ml-2",
    attrs: {
      "outline": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("\n        ביטול\n        "), _c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("block")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c52499b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PopupStatus.vue
// module id = 912
// module chunks = 2